import React from 'react';
import { motion } from 'framer-motion';
import { ReactTyped, Typed } from 'react-typed';

const Hero = () => {
  return (
    <motion.section
      className="hero"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
    >
      <div className="hero-content">
        <motion.h1
          className="hero-title"
          initial={{ y: 50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.8 }}
        >
          <ReactTyped
            strings={[
              "Full Stack Developer",
              "Aspiring Software Engineer",
              "Emerging Data Scientist",
              "Problem Solver"
            ]}
            typeSpeed={100}
            backSpeed={50}
            loop
          />
        </motion.h1>

        <motion.p
          className="hero-subtitle"
          initial={{ y: 30, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.4, duration: 0.8 }}
        >
          Undergraduate at IITM • Class of 2027
        </motion.p>

        <motion.p
          className="hero-description"
          initial={{ y: 30, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.6, duration: 0.8 }}
        >
          I currently work as a full stack developer and aim to create smart systems as a data scientist or software engineer in the near future.


        </motion.p>

        <motion.a
          href="#contact"
          className="cta-button"
          initial={{ y: 30, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.8, duration: 0.8 }}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          Let's Connect
        </motion.a>
      </div>
    </motion.section>
  );
};

export default Hero;
